import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

// Import components
import AppRoutes from './routes';
import ThemeProvider from './theme/ThemeProvider';
import MuiTheme from './theme/MuiThemeProvider';
import authService from './services/authService';

// App component
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  
  useEffect(() => {
    // Check for authentication on component mount using authService
    const isAuth = authService.isAuthenticated();
    console.log("App mounted, authenticated:", isAuth);
    setIsAuthenticated(isAuth);
    
    // Set up a manual check every second for authentication state changes
    const intervalId = setInterval(() => {
      const currentAuthState = authService.isAuthenticated();
      
      if (currentAuthState !== isAuthenticated) {
        console.log("Auth state changed in interval check:", currentAuthState);
        setIsAuthenticated(currentAuthState);
      }
    }, 1000);
    
    return () => {
      clearInterval(intervalId);
    };
  }, [isAuthenticated]);
  
  return (
    <ThemeProvider>
      <MuiTheme>
        <CssBaseline />
        <Router basename="/vendor-portal">
          <AppRoutes />
        </Router>
      </MuiTheme>
    </ThemeProvider>
  );
}

export default App; 